"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestoreIcon = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const RestoreIcon = ({ fill, size, title = "Restore" }) => (react_1.default.createElement(Base_1.Base, { title: title, size: size ? size : 16, smooth: true },
    react_1.default.createElement("path", { fill: fill ? fill : "#E6E6E6", opacity: "1", d: "M16,8C16,11.9,12.9,15,9,15L9,13C11.8,13 14,10.8 14,8 14,5.2 11.8,3 9,3 6.2,3 4,5.2 4,8L6,8 3,12 0,8 2,8C2,4.1 5.1,1 9,1 12.9,1 16,4.1 16,8z" }),
    react_1.default.createElement("path", { fill: fill ? fill : "#E6E6E6", opacity: "1", d: "M10,5L10,9 10,9 7,13 5.4,11.8 8,8.3 8,5 10,5z" })));
exports.RestoreIcon = RestoreIcon;
//# sourceMappingURL=Restore.js.map